export const USER_STATUS = {
  NEWLY_CREATED: "newly_created",
  DRAFT: "draft",
  PENDING_VALIDATION: "pending_validation",
  PENDING_BIRTH_DATE_REVIEW: "pending_birth_date_review",
  VALIDATED_WITH_DIVERGENCES: "validated_with_divergences",
  APPROVED: "approved",
  REJECTED: "rejected",
  SUSPENDED: "suspended",
  QUARANTINED: "quarantined",
  CLEARED: "cleared",
  BLOCKED: "blocked",
  TRUSTED: "trusted",
  FOREIGN_USER: "foreign_user",
};

export const LEGACY_TO_CURRENT_USER_STATUS: Record<string, string> = {
  unsuspended: USER_STATUS.CLEARED,
  manual_unsuspended: USER_STATUS.CLEARED,
  manual_approved: USER_STATUS.APPROVED,
  manual_suspended: USER_STATUS.SUSPENDED,
  manual_trusted: USER_STATUS.TRUSTED,
};

export const normalizeUserStatus = (
  status: string | null | undefined
): string =>
  status ? LEGACY_TO_CURRENT_USER_STATUS[status] ?? status : "";
